import { memo } from 'react'
import Typography from '@mui/material/Typography'
import { Theme, alpha } from '@mui/material/styles'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'
import FakeOffers from 'components/FakeOffers'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import * as CSSTypes from 'csstype'
import useEmotionStyles from 'hooks/useEmotionStyles'
import { scrollToTop } from '../../../utils/pollard/scroll'

const styles = (theme: Theme) => ({
  root: {
    position: 'relative' as CSSTypes.Property.Position,
    width: '100%',
    marginTop: theme.spacing(4)
  },
  overlay: {
    position: 'absolute' as CSSTypes.Property.Position,
    left: 0,
    right: 0,
    bottom: 0,
    maxHeight: '100%',
    overflow: 'auto',
    padding: `${theme.spacing(7.5)} ${theme.spacing(2.5)}`,
    background: alpha(theme.palette.common.black, 0.8),
    color: 'white',

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(7.5)
    }
  },
  overlayTitle: {
    marginBottom: theme.spacing(6.5),

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(3.5)
    }
  },
  overlayList: {
    margin: `0 0 ${theme.spacing(6.5)}`,
    padding: 0,
    listStyle: 'none' as CSSTypes.Property.ListStyle,

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(3.5)
    }
  },
  overlayListItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(6.5),

    '&:last-child': {
      margin: 0
    },

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(3.5)
    }
  },
  checkIcon: {
    fontSize: '1.125rem',
    marginRight: theme.spacing(1.5),
    color: theme.palette.success.main
  }
})

const FakeOfferList = () => {
  const {
    root,
    overlay,
    overlayTitle,
    overlayListItem,
    overlayList,
    checkIcon
  } = useEmotionStyles(styles)
  const { rootStore } = useRootStore()

  return (
    <div className={root}>
      <FakeOffers />
      <div className={overlay}>
        <Typography variant="h3" color="inherit" className={overlayTitle}>
          Warum wir Ihnen Angebote erst nach Eingabe persönlicher Daten anzeigen
        </Typography>
        <ul className={overlayList}>
          <li className={overlayListItem}>
            <CheckIcon className={checkIcon} />
            Bei smava gibt es keine Schaufenster-Zinsen.
          </li>
          <li className={overlayListItem}>
            <CheckIcon className={checkIcon} />
            Vertrauenswürdige Angebote gibt es nur nach einer
            Kreditwürdigkeitsprüfung. Dafür benötigen wir Informationen zu Ihrer
            Person und finanziellen Situation.
          </li>
          <li className={overlayListItem}>
            <CheckIcon className={checkIcon} />
            Nach Eingabe dieser Angaben erhalten Sie von uns einen Überblick
            über die für Sie verfügbaren Kreditangebote.
          </li>
        </ul>
        <Button
          id="scroll-to-top"
          variant="contained"
          fullWidth
          color="primary"
          onClick={() => scrollToTop(rootStore.isInIframe)}
        >
          Kreditvergleich starten
        </Button>
      </div>
    </div>
  )
}

export default memo(FakeOfferList)
